import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback, useMemo, useState } from 'react'
import { shallowEqual } from 'react-redux'

import { useStyles } from './MarketplaceTemplateDimensions.styles'
import { MarketplaceTemplateTableContainer } from './MarketplaceTemplateDimensionTable'
import { MarketplaceFieldMappingDimensions } from '../../../../../../modules/marketplaceMappingManager/types'
import { useSelector } from '../../../../../../store'

export type MarketplaceTemplateDimensionsCardProps = {
  title?: string
  productId: string
  productItem: {
    dimensions: {
      [key: string]: MarketplaceFieldMappingDimensions
    }
    productName: string
  }
}

export const MarketplaceTemplateDimensionsCard = React.memo(
  function MarketplaceTemplateDimensionsCard({
    title = '',
    productId,
    productItem,
  }: MarketplaceTemplateDimensionsCardProps) {
    const { classes } = useStyles()
    const [open, setOpen] = useState<boolean>(false)

    const onSetOpen = useCallback(() => {
      setOpen(prev => !prev)
    }, [])

    return (
      <div className={classes.cardContainer}>
        <div className={classes.cardHeader} onClick={onSetOpen}>
          <div>{title}</div>
          <FontAwesomeIcon
            data-testid={'collapsible-arrow'}
            icon={open ? faChevronUp : faChevronDown}
            className={classes.arrowAction}
          />
        </div>
        {open ? (
          <div className={classes.cardContent}>
            <MarketplaceTemplateTableContainer
              productItem={productItem}
              productId={productId}
            />
          </div>
        ) : null}
      </div>
    )
  }
)

export const MarketplaceTemplateDimensions = () => {
  const { classes } = useStyles()

  const marketplaceTableDetails = useSelector(
    state =>
      state.marketplaceMappingManager?.templateData?.templateData?.fieldMappings
        ?.dimensions?.dimensionsMapping,
    shallowEqual
  )

  const marketplaceTableDetailsList = useMemo(() => {
    if (!marketplaceTableDetails) return []
    return Object.entries(marketplaceTableDetails).map(([key, value]) => ({
      key,
      value,
    }))
  }, [marketplaceTableDetails])

  return (
    <div className={classes.dimensionsContainer}>
      {marketplaceTableDetailsList.map(({ key, value }) => (
        <MarketplaceTemplateDimensionsCard
          key={key}
          title={value?.productName || key}
          productId={key}
          productItem={value}
        />
      ))}
    </div>
  )
}
